export const CONTRIBUTOR_CREDITS_FLOW_ID =
  'a5b2c4d6-e8f0-4123-b456-789012345678';

const SUPPORTED_FLOW_IDS = new Set([CONTRIBUTOR_CREDITS_FLOW_ID]);

export const isSupportedEnrichardFlowId = (flowId: unknown): flowId is string =>
  typeof flowId === 'string' && SUPPORTED_FLOW_IDS.has(flowId);
